<template>
  <!-- 专业就业市场分析 -->
  <div class="page">
    <!-- 第一层 -->
    <el-row :gutter="12" class="sameLayer">
      <el-col :span="24">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>本专业面向职业需求排名（10名）</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <tcolumnarChart :refId="'rankingChart'" :datas='ranking.dataList' :transverseData='ranking.transverseData' :colorList='ranking.colorList' :gridY="'12%'" :gridHeight="'83%'" :innerText="'单位：条'"></tcolumnarChart>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="12" class="sameLayer">
      <el-col :span="24">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>本专业面向职业薪酬排名（10名）</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <tcolumnarChart :refId="'rankingChart'" :datas='posts.dataList' :transverseData='posts.transverseData' :colorList='posts.colorList' :gridY="'12%'" :gridHeight="'83%'" :innerText="'单位：元/月'"></tcolumnarChart>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 第二层 -->
    <el-row :gutter="12" class="sameLayer">
      <el-col :span="16">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>本专业岗位薪酬行业分布情况</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <tcolumnarChart :refId="'professionalChart'" :datas='professional.dataList' :transverseData='professional.transverseData' :colorList='professional.colorList' :gridY="'6%'" :gridHeight="'85%'"></tcolumnarChart>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>本专业招聘单位分布情况</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <circularChart :refId="'disciplineChart'" :datas='discipline.dataList' :isScroll='discipline.isScroll' :height='discipline.height' :colorName='1' :innerText="'数量'"></circularChart>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 第三层 -->
    <el-row :gutter="12" class="sameLayer">
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>全国区域本专业人才薪资分布</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <circularChart :refId="'countryChart'" :datas='country.dataList' :isScroll='country.isScroll' :height='country.height' :colorName='1' :innerText="'数量'"></circularChart>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>全国区域本专业人才学历要求分布</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <circularChart :refId="'regionsChart'" :datas='regions.dataList' :isScroll='regions.isScroll' :height='regions.height' :colorName='1' :innerText="'数量'"></circularChart>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>全国区域本专业人才工作经验要求分布</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <circularChart :refId="'requirementsChart'" :datas='requirements.dataList' :isScroll='requirements.isScroll' :height='requirements.height' :colorName='1' :innerText="'数量'"></circularChart>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 第四层 -->
    <el-row :gutter="12" class="sameLayer">
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>院校所在区域（{{province}}）本专业人才薪资分布情况</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <circularChart :refId="'universityChart'" :datas='university.dataList' :isScroll='university.isScroll' :height='university.height' :colorName='2' :innerText="'数量'"></circularChart>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>院校所在区域（{{province}}）本专业人才学历要求情况</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <circularChart :refId="'locatedChart'" :datas='located.dataList' :isScroll='located.isScroll' :height='located.height' :colorName='2' :innerText="'数量'"></circularChart>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>院校所在区域（{{province}}）本专业人才经验要求情况</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">

            <!-- <circularChart :refId="'talentsChart'" :datas='talents.dataList' :isScroll='talents.isScroll' :height='talents.height' :colorName='2' :innerText="'数量'"></circularChart> -->
            <roseEchart :refId="'talentsChart'" :datas='talents.dataList' :innerText="'数量'"></roseEchart>

          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 第五层 -->
    <el-row :gutter="12" class="sameLayer">
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>本专业市场需求所属行业分布</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <roseEchart :refId="'distributionChart'" :datas="distribution.dataList" :colorList="distribution.colorList" :titleText="'本专业市场需求所属行业分布'"></roseEchart>
          </div>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>本专业岗位薪酬地域分布情况</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <tcolumnarChart :refId="'salarypostsChart'" :datas='salaryposts.dataList' :transverseData='salaryposts.transverseData' :colorList='salaryposts.colorList' :gridY="'6%'" :gridHeight="'85%'"></tcolumnarChart>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 地图 -->
    <el-row :gutter="12" class="mapFloor" ref="maps">
      <el-col :span="24">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>全国区域本专业市场需求分布</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content">
            <hotMapChart :refId="'mapChart'" :datas='map.dataList' :legendList="map.legendList" :colorList="map.colorList"></hotMapChart>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>


<script>
import pictureCharts from '@/components/chart/pictureCharts.vue'    //词云图
import tcolumnarChart from '@/components/chart/tcolumnarChart.vue'    //横着的柱状图
import circularChart from '@/components/chart/circularChart.vue'    //圆形图
// import majorMap from '@/components/chart/majorMap.vue'    //专业就业地图
import hotMapChart from '@/components/chart/hotMapChart.vue'    //专业就业地图
import roseEchart from '@/components/chart/roseChart.vue'    //专业就业地图


export default {
  components: {
    pictureCharts,
    tcolumnarChart,
    circularChart,
    // majorMap,
    hotMapChart,
    roseEchart
  },
  data() {
    return {
      dataSourcesList: [],  //数据源
      dataSourcess: '',  //选中的数据源

      dataTextObj: {    //数据来源下的内容
        globeCount: null,
        currentArea: "",
        currentAreaCount: null
      },

      // 第一层
      picture: {   //词云图
        dataList: [],
        colorList: []
      },
      ranking: {    // 本专业岗位需求排名(15名)
        transverseData: [],
        dataList: [],
        colorList: [],
      },
      posts: {    // 本专业岗位薪酬排名
        transverseData: [],
        dataList: [],
        colorList: [],
      },


      // 第二层
      professional: {   //本专业岗位薪酬行业分布情况
        transverseData: [],
        dataList: [],
        colorList: []
      },
      discipline: {    //本专业招聘单位分布情况
        dataList: [],
        isScroll: false,
        height: 280,
      },


      // 第三层
      country: {  // 全国区域本专业人才薪资分布情况
        dataList: [],
        isScroll: false,
        height: 280,
      },
      regions: {// 全国区域本专业人才学历要求情况
        dataList: [],
        isScroll: false,
        height: 280,
      },
      requirements: {// 全国区域本专业人才经验要求情况
        dataList: [],
        isScroll: false,
        height: 280,
      },


      // 第四层
      university: {  // 院校所在区域()本专业人才薪资分布情况
        dataList: [],
        isScroll: false,
        height: 280,
        padding: []
      },
      located: {  // 院校所在区域()本专业人才学历要求情况
        dataList: [],
        isScroll: false,
        height: 280,
      },
      talents: {  // 院校所在区域()本专业人才经验要求情况
        dataList: [],
        isScroll: false,
        height: 280,
      },


      // 第五层
      distribution: {  // 本专业岗位需求行业分布情况
        dataList: [],
        distribution: [],
        isScroll: false,
        height: 280,
      },
      salaryposts: {  //本专业岗位薪酬地域分布情况
        dataList: [],
        transverseData: [],
        colorList: []
      },
      province: '',
      map: {     //地图
        arr1: [],
        arr2: [],
        dataList: [],
        legendList: ['专业岗位区域分布', '全国区域专业开设分布'],
        colorList: ['#40f1f6', '#fd891c']
      },
    }
  },
  created() {
    this.province = sessionStorage.getItem('province')
    // 第一层
    this.rankingDom()
    // 第二层
    this.postsDom()
    // 第三层
    this.professionalDom()
    this.disciplineDom()
    // 第三层
    this.countryDom()
    this.regionsDom()
    this.requirementsDom()
    // 第四层
    this.universityDom()
    this.locatedDom()
    this.talentsDom()
    // 第五层
    this.distributionDom()
    this.salarypostsDom()
    // 第六层
    this.postsAcrossDom1()
    this.postsAcrossDom2()
  },
  methods: {
    // 获取数据源下面的内容
    dataText(dataSourcess) {
      this.$axios.post(this.$apiurls.marketAnalysis_dataText, {
        dataVersion: dataSourcess,
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.dataTextObj = res.data
        }
      });
    },
    // 本专业岗位需求排名(15名)
    rankingDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getProfessionHotJob, 4, {
        loading: false,
      }).then((res) => {
        if (res) {
          res.data.data.list.forEach(item => {
            this.ranking.transverseData.push(item.name)
            this.ranking.dataList.push(item.num)
          })
          this.ranking.colorList = ['#1BF6F8']
        }
      });
    },
    // 第二层
    // 本专业岗位薪酬排名
    postsDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getProfessionHotJob, 5, {
        loading: false,
      }).then((res) => {
        if (res) {
          res.data.data.list.forEach(item => {
            this.posts.transverseData.push(item.name)
            this.posts.dataList.push(item.num)
          })
          this.posts.colorList = ['#1BF6F8']
        }
      });
    },
    // 第三层
    // 本专业岗位薪酬行业分布情况
    professionalDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getProfessionEnterpriseNum, {
        loading: false,
      }).then((res) => {
        if (res) {
          res.data.data.forEach(item => {
            this.professional.transverseData.push(item.name)
            this.professional.dataList.push(item.num)
          })
          this.professional.colorList = ['#40f1f6']
        }
      });
    },
    // 本专业招聘单位分布情况
    disciplineDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getProfessionEnterpriseTypeNum, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res.data.length > 8) {
            this.discipline.isScroll = true
          } else {
            this.discipline.isScroll = false
          }
          this.discipline.height = 280
          this.discipline.dataList = res.data.data.list.map(item => {
            let name = item.name
            let value = item.num
            return {
              name,
              value
            }
          })
        }
      });
    },
    // 第四层
    // 全国区域本专业人才薪资分布情况
    countryDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getProfessionalInstructionsStatisticsByMajorId, 1, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.country.height = 280
          res.data.data.find(item => item.labelText == null).labelText = '其他'
          this.country.dataList = res.data.data.map(item => {
            let name = item.labelText
            let value = item.num
            return {
              name,
              value
            }
          })

          // this.
        }
      });
    },
    // 全国区域本专业人才学历要求情况
    regionsDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getProfessionalInstructionsStatisticsByMajorId, 2, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.regions.height = 280
          this.regions.dataList = res.data.data.map(item => {
            let name = item.labelText
            let value = item.num
            return {
              name,
              value
            }
          })
        }
      });
    },
    // 全国区域本专业人才经验要求情况 
    requirementsDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getProfessionalInstructionsStatisticsByMajorId, 3, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.requirements.height = 280
          this.requirements.dataList = res.data.data.map(item => {
            let name = item.labelText
            let value = item.num
            return {
              name,
              value
            }
          })
        }
      });
    },
    // 第五层
    // 院校所在区域()本专业人才薪资分布情况
    universityDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getSalaryNum, '北京', {
        loading: false,
      }).then((res) => {
        if (res) {
          this.university.height = 280
          this.university.dataList = res.data.data.map(item => {
            let name = item.labelText
            let value = item.num
            return {
              name,
              value
            }
          })
        }
      });
    },
    // 院校所在区域()本专业人才学历要求情况
    locatedDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getEducationNum, '北京', {
        loading: false,
      }).then((res) => {
        if (res) {
          this.located.height = 280
          this.located.dataList = res.data.data.map(item => {
            let name = item.labelText
            let value = item.num
            return {
              name,
              value
            }
          })
        }
      });
    },
    // 院校所在区域()本专业人才经验要求情况
    talentsDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getWorkingYearsNum, '北京', {
        loading: false,
      }).then((res) => {
        if (res) {
          this.talents.height = 280
          this.talents.dataList = res.data.data.map(item => {
            let name = item.labelText
            let value = item.num
            return {
              name,
              value
            }
          })
        }
      });
    },
    // 第六层
    // 本专业岗位需求行业分布情况
    distributionDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getPostNum, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.distribution.height = 280
          this.distribution.dataList = res.data.data.map(item => {
            let name = item.name
            let value = item.num
            return {
              name,
              value
            }
          })
          // this.distribution.colorList = ['#FD398E', '#FE6695', '#FE80A7', '#FBBBD7', '#FED0E4', '#FCDFF3', '#FFB1E7', '#FFA5D5', '#FF98B7', '#FEAAA0', '#FFBFAF', '#FFD1A2', '#FBE0BD', '#FEFFDF', '#FFDEE6', '#FFBFDB', '#FFD1E4', '#FCD4D8', '#FFAFC2', '#FF6D9F', '#FFCBD1']; // 粉色
        }
      });
    },
    // 本专业岗位薪酬地域分布情况
    salarypostsDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getEnterpriseRegion, {
        loading: false,
      }).then((res) => {
        if (res) {
          res.data.data.list.forEach(item => {
            this.salaryposts.transverseData.push(item.name)
            this.salaryposts.dataList.push(item.num)
          })
          this.salaryposts.colorList = ['#1BF6F8']
        }
      });
    },
    // 全国区域本专业岗位需求分布情况 地图
    postsAcrossDom1() {
      this.$axios.post(this.$apiurls.marketAnalysis_getCityPostOrSchoolNum, 1, {
        loading: false,
      }, { timeout: 3 * 60 * 1000 }).then((res) => {
        if (res) {
          this.map.arr1.push(res.data.data)
        }
      });
    },
    postsAcrossDom2() {
      this.$axios.post(this.$apiurls.marketAnalysis_getCityPostOrSchoolNum, 2, {
        loading: false,
      }, { timeout: 3 * 60 * 1000 }).then((res) => {
        if (res) {

          this.map.arr2.push(res.data.data)
          this.map.dataList = this.map.arr1.concat(this.map.arr2)
        }
      });
    }
  }
}
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" scoped>
/* 第一层 */
.firstFloor {
  height: 760px;
  position: relative;
  margin-bottom: 8px;
}
.firstFloor .el-col {
  height: 100%;
  position: relative;
}

.record {
  display: flex;
  justify-content: space-between;
  flex-flow: column;
}
/* 数据来源 */
.table-search-box {
  position: relative;
  width: 100%;
  height: 370px;
  // height: 270px;
  margin-bottom: 12px;
}

.introduce {
  padding: 20px;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 3px;
  color: #707f9d;
}

/* 岗位词云图 */
.picture {
  position: relative;
  width: 100%;
}

.firstFloor .echartsHeight {
  width: 100%;
  height: 335px;
  // height: 270px;
}

.firstFloor .echartsHeightDemand {
  width: 100%;
  height: 714px;
}

/* 第二层 ,第三层 ,第四层,第五层  */
.sameLayer {
  position: relative;
  margin-bottom: 12px;
}

.sameLayer .el-col {
  height: 400px;
}

.sameLayer .echartsHeight {
  width: 100%;
  height: 380px;
}

/* 地图 */
.mapFloor .el-col {
  height: 800px;
  position: relative;
}

.mapFloor .echartsHeightMap {
  width: 100%;
  height: 740px;
}
</style>